import React from "react";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";

const UserInput = ({ isResearcher, disabled, ...props }) => {
  if (disabled && isResearcher) {
    return null;
  }
  return (
    <ReferenceAutocompleteInput
      {...props}
      reference="users"
      optionText="name"
      disabled
    />
  );
};
export default UserInput;
